/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "2e66dbea319de767eb552f37bd3ec8a7e2e9ee19";
